import { Link } from "react-router-dom"
import "./index.scss"

const Footer = () => {
  const startYear = 2023
  const currentYear = new Date().getFullYear()

  return (
    <footer className="site-footer" aria-label="Pied de page du site">
      <div className="site-footer-inner">
        <p className="site-footer-copyright">
          Copyright © sdley {startYear} - {currentYear}. Tous droits réservés.
        </p>

        <nav className="site-footer-links" aria-label="Liens utiles">
          <a
            href="https://github.com/sdley"
            target="_blank"
            rel="noopener noreferrer"
          >
            GitHub
          </a>
          <a
            href="https://www.linkedin.com/in/sdley/"
            target="_blank"
            rel="noopener noreferrer"
          >
            LinkedIn
          </a>
          <a href="mailto:sdley2020@gmail.com">Email</a>
          <Link to="/portfolio">Portfolio</Link>
          <Link to="/activities">Activités</Link>
          <Link to="/contact">Contact</Link>
        </nav>
      </div>
    </footer>
  )
}

export default Footer
